import { newProductConstant } from '../../constants/product/newProduct.constant';
import { useGetNewOpenMarketProductQuery } from '../api/product/queries/useGetNewOpenMarketProduct.query';
import { useGetNewProductQuery } from '../api/product/queries/useGetNewProduct.query';

export const useGetNewProduct = () => {
  const { data: newProduct } = useGetNewProductQuery({ searchParam: { category: newProductConstant.market.category } });
  const { data: newOpenMarketProduct } = useGetNewOpenMarketProductQuery();

  return { newProduct, newOpenMarketProduct };
};
